
    import * as React from 'react';

    const Prev24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M10.387 18.285L9.65 19 2 12l7.65-7 .737.715-6.325 5.787H22v.996H4.062z" /></svg>
        </div>
      );
    };

    Prev24.displayName = 'Prev24';

    export default Prev24;
  